import React from 'react';
import styles from './Select.module.css';

export interface SelectOption {
  value: string | number;
  label: string;
}

export interface SelectOptionGroup {
  label: string;
  options: SelectOption[];
}

export interface SelectProps {
  label: string;
  id: string;
  options?: SelectOption[];
  /** Grouped options — when provided, renders <optgroup> elements */
  groups?: SelectOptionGroup[];
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  error?: string;
}

const Select: React.FC<SelectProps> = ({
  label,
  id,
  options = [],
  groups,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  className = '',
  error,
  ...props
}) => {
  return (
    <div
      className={`uc-form-group ${styles.group} ${className} ${error ? 'uc-form-group--error' : ''}`}
    >
      <label htmlFor={id} className={styles.label}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </label>
      <div className={styles.selectWrapper}>
        <select
          id={id}
          className={`uc-input-style ${styles.select}`}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {groups
            ? groups.map((group) => (
                <optgroup key={group.label} label={group.label}>
                  {group.options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </optgroup>
              ))
            : options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
        </select>
      </div>
      {error && (
        <div
          className="uc-form-feedback"
          style={{ color: 'var(--color-danger)', fontSize: '0.875rem', marginTop: '0.25rem' }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default Select;
